import { ClientProfileResponse } from '../client-info/get-profile-client'
import { axios, Response } from '../index'

const editPatientDetails = (
  patientId: string,
  avatarUrl: string
): Response<ClientProfileResponse> => {
  return axios.patch(`/v1/patients/${patientId}`, {
    avatarUrl: avatarUrl
  })
}

export default editPatientDetails
